import {Injectable} from '@angular/core';
import {HttpService} from '../services/http-service';
import {Observable} from 'rxjs';

@Injectable()
export class DictionaryService {
    constructor (private httpService: HttpService) {

    }

    owners(): Observable<any[]> {
        return this.httpService.get('/api/dictionary/owners');
    }

    currencies(): Observable<any[]> {
        return this.httpService.get('/api/dictionary/currencies');
    }

    accountCurrencies(): Observable<any[]> {
        return this.httpService.get('/api/dictionary/account-currencies');
    }

    countries(): Observable<any[]> {
        return this.httpService.get('/api/dictionary/countries');
    }

    activityTypes(): Observable<any[]> {
        return this.httpService.get('/api/dictionary/activity-types');
    }

    transferPurposes(): Observable<any[]> {
        return this.httpService.get('/api/dictionary/transfer-purposes');
    }
}
